export default __webpack_public_path__ + "static/media/avatar.ad76f76d.svg";